import { LuCircleDollarSign } from 'react-icons/lu'
import Button from './Buttons'
import Modal from './Modals/Modal'

const ReferralModal = ({ setModalOpen, open }: { setModalOpen: (open: boolean) => void; open: boolean }) => {
	return (
		<Modal open={open} closeModal={() => setModalOpen(false)}>
			<div className="max-w-md p-6">
				<div>
					<div className="flex items-center gap-2 text-xl font-semibold">
						<div className="p-2 bg-success-light rounded-full">
							{LuCircleDollarSign({ className: 'h-5 w-5 text-success-dark' })}
						</div>
						Referral Program
					</div>
					<div className="mt-2 text-gray-700">
						Earn money by sharing our AI writing tools with your friends and followers.
					</div>
				</div>
				<div className="space-y-6 mt-4">
					<div className="space-y-4">
						<div className="flex items-start gap-3">
							<div className="w-6 h-6 bg-success-light rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
								<span className="text-success-dark text-sm font-semibold">1</span>
							</div>
							<div>
								<h4 className="font-medium text-slate-900">Share your link</h4>
								<div className="text-sm text-slate-600">Get your unique referral link and share it with friends</div>
							</div>
						</div>
						<div className="flex items-start gap-3">
							<div className="w-6 h-6 bg-success-light rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
								<span className="text-success-dark text-sm font-semibold">2</span>
							</div>
							<div>
								<h4 className="font-medium text-gray-900">They sign up</h4>
								<div className="text-sm text-gray-600">
									When someone joins after clicking your link, you both benefit
								</div>
							</div>
						</div>
						<div className="flex items-start gap-3">
							<div className="w-6 h-6 bg-success-light rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
								<span className="text-success-dark text-sm font-semibold">3</span>
							</div>
							<div>
								<h4 className="font-medium text-gray-900">Earn rewards</h4>
								<div className="text-sm text-gray-600">Get 30% commission on all future purchases</div>
							</div>
						</div>
					</div>

					<div className="bg-gradient-to-r from-success-light to-success-light p-4 rounded-lg border border-success-default">
						<div className="text-center">
							<div className="text-2xl font-bold text-success-dark">30%</div>
							<div className="text-sm text-success-dark">Commission Rate</div>
						</div>
					</div>

					<Button
						type="default"
						className="w-full bg-success-dark hover:bg-success-dark/80 text-white"
						onClick={() => {
							window.open('https://good-ai.getrewardful.com/signup', '_blank')
						}}
					>
						Join Referral Program
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default ReferralModal
